import type { SxProps, Theme } from '@mui/material/styles';

import { applyColors } from '../../features/application/styles/theme';

export const pageRootSx: SxProps<Theme> = {
  position: 'fixed',
  inset: 0,
  zIndex: 2000,
  minHeight: '100vh',
  width: '100%',
  overflowY: 'auto',
  backgroundColor: applyColors.background,
};

export const bgImgSx = {
  rightFade: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    pointerEvents: 'none',
    zIndex: 0,
    width: { xs: '50%', sm: '40%', md: '35%', lg: 'auto' },
    maxWidth: '100%',
    opacity: 0.8,
  } as SxProps<Theme>,
  leftStar: {
    position: 'fixed',
    top: 0,
    right: 0,
    pointerEvents: 'none',
    zIndex: 0,
    width: { xs: '50%', sm: '40%', md: '35%', lg: 'auto' },
    maxWidth: '100%',
    opacity: 0.8,
  } as SxProps<Theme>,
};

export const contentSx: SxProps<Theme> = {
  position: 'relative',
  zIndex: 1,
  minHeight: '100vh',
  width: '100%',
  maxWidth: 720,
  mx: 'auto',
  px: { xs: 2, md: 4 },
  py: { xs: 6, md: 8 },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: { xs: 3, md: 4 },
  textAlign: 'center',
};

export const logoSx: SxProps<Theme> = {
  width: { xs: 190, md: 240 },
  height: 'auto',
};

export const cardSx: SxProps<Theme> = {
  width: '100%',
  borderRadius: '20px',
  border: `1px solid ${applyColors.border}`,
  backgroundColor: applyColors.panel,
  p: { xs: 3, sm: 4, md: 5 },
  boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 2.5,
};

export const iconWrapSx: SxProps<Theme> = {
  width: 72,
  height: 72,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: applyColors.accentSoft,
  backgroundColor: '#99A8FF14',
  border: `1px solid ${applyColors.borderStrong}`,
};

export const iconWrapSuccessSx: SxProps<Theme> = {
  ...(iconWrapSx as object),
  color: applyColors.success,
  backgroundColor: '#27D34814',
  border: `1px solid ${applyColors.success}55`,
};

export const titleSx: SxProps<Theme> = {
  fontSize: { xs: 24, sm: 28, md: 32 },
  fontWeight: 700,
  letterSpacing: '-0.02em',
  color: '#FFFFFF',
  lineHeight: 1.2,
};

export const subtitleSx: SxProps<Theme> = {
  fontSize: { xs: 14, md: 16 },
  color: applyColors.textBody,
  maxWidth: 520,
  lineHeight: 1.6,
};

export const progressSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: 320,
  height: 4,
  borderRadius: 999,
  backgroundColor: '#99A8FF1F',
  '& .MuiLinearProgress-bar': { backgroundColor: applyColors.primary },
};

export const statusLineSx: SxProps<Theme> = {
  fontSize: 13,
  color: applyColors.textMuted,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const retryButtonSx: SxProps<Theme> = {
  backgroundColor: applyColors.primary,
  color: '#FFFFFF',
  fontWeight: 700,
  fontSize: 15,
  textTransform: 'none',
  borderRadius: '12px',
  py: 1.2,
  px: 3.5,
  boxShadow: 'none',
  '&:hover': { backgroundColor: applyColors.primaryHover, boxShadow: 'none' },
  '&.Mui-disabled': { backgroundColor: '#354EEF66', color: '#FFFFFF99' },
};

export const supportSx: SxProps<Theme> = {
  fontSize: 13,
  color: applyColors.textMuted,
  '& a': { color: applyColors.accent, textDecoration: 'none' },
  '& a:hover': { textDecoration: 'underline' },
};

export const langButtonSx: SxProps<Theme> = {
  position: 'fixed',
  top: { xs: 12, md: 'auto' },
  bottom: { xs: 'auto', md: 24 },
  right: { xs: 12, md: 24 },
  zIndex: 2001,
  backgroundColor: applyColors.panel,
  border: `1px solid ${applyColors.border}`,
  color: applyColors.accent,
  '&:hover': { backgroundColor: '#252633' },
};
